import React, { useState, useEffect,useContext } from "react";
// import PasswordInputField from "./PasswordInputField";
// import ConfirmPasswordInputField from "./ConfirmPasswordInputField";
import tmdbApi from "../api/tmdbApi";
import Footer from "../components/footer/Footer";
import axios from "axios";
// import "../../src/assets/css/style.css"
import * as Config from "../constants/Config";
import { useNavigate } from "react-router-dom";
import { contentContext } from "../context/contentContext";
let {lambda,appname}=window.app;


function GeneratePassword() {
    const navigate = useNavigate();
    const [passwordError, setPasswordErr] = useState("");
    const [confirmPasswordError, setConfirmPasswordError] = useState("");
    const [passwordShown, setPasswordShown] = useState(false);
    const [number, setNumber] = useState(false);
    const [upper, setUpper] = useState(false);
    const [limit, setLimit] = useState(false);
    const [lower, setLower] = useState(false);
    const [special, setSpecial] = useState(false);
    const [error, setError] = useState('');
    const [config, setConfig] = useState({});
    const [btnLoader, setBtnLoader] = useState(false);
    const [passwordInput, setPasswordInput] = useState({
        password: '',
        confirmPassword: ''
    })
    // const [menus, setMenus] = useState([]);
    const [email, setEmail] = useState([]);
    const [locData,setLocData] = useState("");

    const {welcomeMsg, setWelcomeMsg} = useContext(contentContext)

    const { menus } = useContext(contentContext);
    useEffect(() => {
        // appMenus();
        getUserData();
        setEmail(localStorage.getItem("email"))
        setLocData(JSON.parse(localStorage.getItem("loc")));
    }, []);
    useEffect(() => {
        if (typeof window.websiteDefaults === "function") {
    window.websiteDefaults();
  }
        if (typeof window.websiteDefaults === "function") {
    window.websiteDefaults();
  }
        if(window.site){
          setConfig(window.site);
         
        }
       
      }, [window.site]);
    
      if(config.common && config.common.imagesCDN ){
        var img = config.common.imagesCDN;
      }
    // const appMenus = async () => {
    //     try {
    //         console.log(tmdbApi);
    //         const response = await tmdbApi.appMenus({result : "micro"});
    //         setMenus(response.result)
    //         console.log(response);
    //     } catch {
    //         console.log("error");
    //     }
    // };

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const id = urlParams.get("id");

    const getUserData = async (e) => {
        console.log('getuserdata')
        axios({
            method: 'GET',
            url: lambda + '/client?appname=' + appname + '&clientid='+ id,
        })
            .then(function (response) {
                console.log('response',response)
                if(response?.data?.result === "Client not found"){
                    setEmail("")
                    navigate("/");
                }
                else if(response?.data?.result?.result.length>0){
                    console.log("resp",response);
                    setEmail(response?.data?.result?.result[0]?.personalemail)
                }
                else{
                    setEmail("")
                    navigate("/");
                }
               

            });

    }
    const handlePasswordChange = (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        const NewPasswordInput = { ...passwordInput, [passwordInputFieldName]: passwordInputValue }
        setPasswordInput(NewPasswordInput);

    }
    const handleAddclass = (evnt) => {
        var element = document.getElementById("instruction");
        element.classList.add("ins-dsp-none");
        setConfirmPasswordError("");
    }
    const handleRemoveclass = (evnt) => {
        var element = document.getElementById("instruction");
        element.classList.remove("ins-dsp-none");
    }
    // const handleConfirm = (evnt) => {
    //     const passwordInputFieldName = evnt.target.name;
    //     if (passwordInputFieldName === "confirmPassword" || (passwordInputFieldName === "password")) {
              
    //         if (passwordInput.confirmPassword !== passwordInput.password) {
    //             setConfirmPasswordError("Confirm password is not matched");
    //         } else {
    //             setConfirmPasswordError("");
    //         }

    //     }
    // }
    const handleValidation = (evnt) => {
        const passwordInputValue = evnt.target.value.trim();
        const passwordInputFieldName = evnt.target.name;
        //for password 
        if (passwordInputFieldName === 'password') {
            const uppercaseRegExp = /(?=.*?[A-Z])/;
            const lowercaseRegExp = /(?=.*?[a-z])/;
            const digitsRegExp = /(?=.*?[0-9])/;
            const specialCharRegExp = /(?=.*?[#?!@$%^&*-])/;
            const minLengthRegExp = /.{8,}/;
            const passwordLength = passwordInputValue.length;
            const uppercasePassword = uppercaseRegExp.test(passwordInputValue);
            const lowercasePassword = lowercaseRegExp.test(passwordInputValue);
            const digitsPassword = digitsRegExp.test(passwordInputValue);
            const specialCharPassword = specialCharRegExp.test(passwordInputValue);
            const minLengthPassword = minLengthRegExp.test(passwordInputValue);
            let errMsg = "";
            if (passwordLength === 0) {
                errMsg = "Password is empty";
            }
            // else if (!uppercasePassword) {
            //     errMsg = "At least one Uppercase";
            // } else if (!lowercasePassword) {
            //     errMsg = "At least one Lowercase";
            // } else if (!digitsPassword) {
            //     errMsg = "At least one digit";
            // } else if (!specialCharPassword) {
            //     errMsg = "At least one Special Characters";
            // } else if (!minLengthPassword) {
            //     errMsg = "At least minumum 8 characters";
            // } else {
            //     errMsg = "";
            // }
            if (uppercasePassword) {
                var element = document.getElementById("err1");
                element.classList.add("vaild");
                setUpper(true);
            } else {
                var element = document.getElementById("err1");
                element.classList.remove("vaild");
                setUpper(false);
            }
            if (lowercasePassword) {
                var element = document.getElementById("err");
                element.classList.add("vaild");
                setLower(true);
            } else {
                var element = document.getElementById("err");
                element.classList.remove("vaild");
                setLower(false);
            }
            if (digitsPassword) {
                var element = document.getElementById("err2");
                element.classList.add("vaild");
                setNumber(true);
            } else {
                var element = document.getElementById("err2");
                element.classList.remove("vaild");
                setNumber(false);
            }
            if (specialCharPassword) {
                var element = document.getElementById("err3");
                element.classList.add("vaild");
                setSpecial(true)
            } else {
                var element = document.getElementById("err3");
                element.classList.remove("vaild");
                setSpecial(false)
            }
            if (minLengthPassword) {
                var element = document.getElementById("err4");
                element.classList.add("vaild");
                setLimit(true)
            } else {
                var element = document.getElementById("err4");
                element.classList.remove("vaild");
                setLimit(false)
            }
            if (limit && upper && special && lower && number && confirmPasswordError === "") {
                setError("")
            }

           
            setPasswordErr(errMsg);
        }
       
    }
    const togglePassword = (e) => {
        setPasswordShown(!passwordShown);
    };

    const handlePwdGenerate = (e) => {
      
        if(passwordInput.password == ""){
            if(id){
                setError("Please Enter New Password");
                setTimeout(function () { setError("") }, 4000);
            }else{
                setError("Please Enter Password");
                setTimeout(function () { setError("") }, 4000);
            }
            
            

        }else if(passwordInput.confirmPassword === ""){
            setError("Please Enter Confirm Password");
            setTimeout(function () { setError("") }, 4000);

        }
        else if (passwordInput.confirmPassword !== passwordInput.password) {
            setConfirmPasswordError("Confirm password is not matched");
            // setTimeout(function () { setConfirmPasswordError("") }, 3000);
        }
        //else if(lower === false && number === false && limit === false && lower === false && special === false){
        //     setError("Please Enter Strong Password");
        //     setTimeout(function () { setError("") }, 3000);

        // }
       else if (!limit || !upper || !special || !lower || !number){
      
            setError("Please enter the password as per the instructions");
            // setTimeout(function () { setError("") }, 3000);
        
     }
       else if (limit && upper && special && lower && number && confirmPasswordError === "") {
        setError("")
        
          if(passwordInput.password === passwordInput.confirmPassword){
            setConfirmPasswordError("")
            
            pwdGenerate();
          }
        }
     
    }

    const pwdGenerate = async () => {
        setBtnLoader(true)
        try {
            const response = await tmdbApi.pwdGenerate({
                "emailid": email,
                "password": passwordInput.password,
                 "useragent" : locData?.headers !== undefined ? locData?.headers : {}
            });
            console.log(response.result.token);
           if(response.result.token){
             window.localStorage.setItem("token",response.result.token);
             window.localStorage.setItem("login","setlogin"); 
             window.localStorage.setItem("clientid",response.result.clientid); 

             let currentDate = new Date().toJSON();
             window.localStorage.setItem("currentSessionClientTime",currentDate); 
             setWelcomeMsg(true)
             navigate("/content")
           }
           setBtnLoader(false)
        } catch {
            setBtnLoader(false)
            console.log("error");
        }
    };

    function handleClose() {
        navigate("/");
    }
    return (
        <>
          {/* <button 
  className="close-btn" 
  id="close-button" 
  data-testid="close-button" 
  onClick={handleClose}
>
  <span className="material-icons">close</span>
</button> */}
 <div className="header-wrapper">

        <a className="navbar-brand" onClick={handleClose}>
          <img src={`${img}orasi/client/resources/orasiv1/images/logo_white.png`} alt="Logo" />
          
        </a>

        {/* <p id="signin-signup-prompt" className="signup-prompt">
          Not Registered Yet?<a id="signin-signup-link" href="/signup" className="mx-2">Sign Up</a>
        </p> */}
 <button className="close-btn pwd-close" onClick={handleClose}><span className="material-icons">close</span></button>
      </div>
 
            <div className="sign-in-bg"></div>
<div className="signin-wrapper  create-password forgotpwd-wrapper">
    <h1>Create Password</h1>
  {/* <a href="/" id="logo-link" >
    <img 
      src={img + "orasi/client/resources/orasiv1/images/logoupdated.png?auto=compress,format"} 
      className="logo" 
      id="logo-img" 
      data-testid="logo-img"
    />
  </a> */}
{/* 
  <p className="strong" id="password-instructions" >
    Create strong and secure passwords to keep your account safe
  </p> */}

  {/* <span className="material-icons-outlined secure-icon" id="secure-icon">lock_person</span> */}

  <div className="crpsd-cnt-blk mt-5">
    <div className="signin-body create-password-body" id="signin-body">
  <div className="signin-section  emaillogin" id="signin-section">

   {/* Email input */}
<div className="mb-3 pwd-group" id="email-input-wrapper">
  <label htmlFor="email-input" className="form-label ">Email<span>*</span></label>
  <input 
    type="email" 
    className="form-control" 
    id="email-input" 
    value={email} 
    placeholder="Enter your email" 
  />
</div>

{/* New Password input */}
<div className="mb-3 pwd-group" id="new-password-input-wrapper">
  <label htmlFor="new-password-input" >New Password<span>*</span></label>
  <input 
    type={passwordShown ? "text" : "password"} 
    value={passwordInput.password} 
    onChange={(e) => handlePasswordChange(e)} 
    onKeyUp={handleValidation} 
    name="password" 
    placeholder="Enter new password" 
    className="form-control"
    id="new-password-input" 
    onBlur={(e) => {handleAddclass(e)}} 
    onFocus={(e) => {handleRemoveclass(e)}} 
  />
  <span className="errormsg" id="new-password-error">{passwordError}</span>
</div>

{/* Confirm Password input */}
<div className="mb-3 pwd-group" id="confirm-password-input-wrapper">
  <label htmlFor="confirm-password-input">Confirm Password<span>*</span></label>
  <input 
    type={passwordShown ? "text" : "password"} 
    value={passwordInput.confirmPassword} 
    onChange={(e) => handlePasswordChange(e)}
    name="confirmPassword" 
    placeholder="Confirm password" 
    className="form-control"
    id="confirm-password-input" 
    onBlur={(e) => {handleAddclass(e)}} 
    onFocus={(e) => {handleRemoveclass(e)}} 
  />
  <p className="text-danger" id="confirm-password-error">{confirmPasswordError}</p>
</div>


    {/* Show Password Checkbox */}
    <div className="flex-left terms-block" id="show-password-wrapper">
      <input 
        type="checkbox" 
        id="show-password-checkbox" 
        onChange={(e) => togglePassword(e)} 
      />
      <label htmlFor="show-password-checkbox"> Show Password.</label>
    </div>

    <span className="errormsg" id="form-error">{error}</span>

    {/* Submit button */}
    <div className="signin-footer mt-4" id="signin-footer">
      <button 
        className="custom-btn-primary about-hero-btn flex items-center justify-center" 
        id="create-password-btn" 
        onClick={e => handlePwdGenerate(e)}
      >
        {btnLoader ? (
          <img 
            src={img + "orasi/client/resources/orasiv1/images/common-icons/rotate_right.svg"} 
            className="loading-icon" 
            id="loading-icon" 
          />
        ) : null}
     <span>Create Password</span>  <span className="material-icons">north_east</span>
      </button>
    </div>
  </div>
</div>


               <div className="create-password-instruction ins-dsp-none" id="instruction">

  <p className="error" id="err" data-testid="error-lowercase">
    {lower ? (
      <span className="material-symbols-outlined">check</span>
    ) : (
      <span className="material-symbols-outlined">close</span>
    )}
    Password must contain a lower case letter
  </p>

  <p className="error" id="err1" data-testid="error-uppercase">
    {upper ? (
      <span className="material-symbols-outlined">check</span>
    ) : (
      <span className="material-symbols-outlined">close</span>
    )}
    Password must contain an upper case letter
  </p>

  <p className="error" id="err2" data-testid="error-number">
    {number ? (
      <span className="material-symbols-outlined">check</span>
    ) : (
      <span className="material-symbols-outlined">close</span>
    )}
    Password must contain a number
  </p>

  <p className="error" id="err3" data-testid="error-special">
    {special ? (
      <span className="material-symbols-outlined">check</span>
    ) : (
      <span className="material-symbols-outlined">close</span>
    )}
    Password must contain a special character or a space
  </p>

  <p className="error" id="err4" data-testid="error-length">
    {limit ? (
      <span className="material-symbols-outlined">check</span>
    ) : (
      <span className="material-symbols-outlined">close</span>
    )}
    Password must contain at least 8 characters
  </p>

</div>

                        </div>

            </div>

            <Footer menus={menus} /></>
    )
}
export default GeneratePassword;